import React from 'react';
import HotListItem from './hotListItem';
class HotList extends React.PureComponent {
    render() {
        const { content, voteData, commentUrl } = this.props;
        if (!content || content.length === 0)
            return null;
        return (React.createElement("div", null, content.map((item, index) => (React.createElement(HotListItem, { key: index, content: item, commentUrl: commentUrl, voteData: voteData })))));
    }
}
export default HotList;
